import type { LayerFeature } from '@vitals/shared';

/** MapLibre-compatible bounds tuple: [[minLng, minLat], [maxLng, maxLat]]. */
export type LngLatBoundsTuple = [[number, number], [number, number]];

/**
 * Compute the bounding box of a set of features.
 * Handles Point and LineString geometries; skips non-finite coordinates.
 * Returns null when the feature list is empty or all coordinates are non-finite.
 */
export function featuresToBounds(
  features: readonly LayerFeature[],
): LngLatBoundsTuple | null {
  let minLng = Infinity;
  let minLat = Infinity;
  let maxLng = -Infinity;
  let maxLat = -Infinity;

  for (const feature of features) {
    const { geometry } = feature;
    if (geometry.type === 'Point') {
      const [lng, lat] = geometry.coordinates;
      if (isFinite(lng) && isFinite(lat)) {
        if (lng < minLng) minLng = lng;
        if (lat < minLat) minLat = lat;
        if (lng > maxLng) maxLng = lng;
        if (lat > maxLat) maxLat = lat;
      }
    } else if (geometry.type === 'LineString') {
      for (const [lng, lat] of geometry.coordinates) {
        if (isFinite(lng) && isFinite(lat)) {
          if (lng < minLng) minLng = lng;
          if (lat < minLat) minLat = lat;
          if (lng > maxLng) maxLng = lng;
          if (lat > maxLat) maxLat = lat;
        }
      }
    }
  }

  if (!isFinite(minLng)) return null;
  return [
    [minLng, minLat],
    [maxLng, maxLat],
  ];
}
